(function(){
  'use strict';
  function publish(name,detail){
    if(window.MOOD_EVENTS&&typeof window.MOOD_EVENTS.publish==='function') window.MOOD_EVENTS.publish(name,detail||{});
    document.dispatchEvent(new CustomEvent(name,{detail:detail||{}}));
  }

  var loyalty=document.querySelector('[data-loyalty-page]');
  if(loyalty){
    loyalty.addEventListener('click',function(event){
      var action=event.target.closest('[data-loyalty-action]');
      if(action) publish('mood_loyalty_action',{action:action.getAttribute('data-loyalty-action')});
      var subscription=event.target.closest('[data-subscription-action]');
      if(subscription) publish('mood_subscription_interest',{action:subscription.getAttribute('data-subscription-action')});
    });
    var video=loyalty.querySelector('.mood-loyalty-film video');
    var toggle=loyalty.querySelector('.mood-loyalty-video-toggle');
    if(video&&toggle){
      function syncVideoButton(){var paused=video.paused;toggle.setAttribute('aria-pressed',paused?'true':'false');toggle.setAttribute('aria-label',paused?'הפעלת הסרטון':'השהיית הסרטון');}
      toggle.addEventListener('click',function(){if(video.paused){video.play().catch(function(){});}else video.pause();syncVideoButton();});
      video.addEventListener('play',syncVideoButton);video.addEventListener('pause',syncVideoButton);syncVideoButton();
    }
  }

  document.querySelectorAll('[data-mood-subscription-options]').forEach(function(root){
    var modes=Array.from(root.querySelectorAll('input[name="mood-purchase-mode"]'));
    var select=root.querySelector('[data-selling-plan-select]');
    function sync(){
      var selected=modes.find(function(input){return input.checked;});
      var subscription=selected&&selected.value==='subscription';
      if(select){select.hidden=!subscription;select.disabled=!subscription;}
      root.setAttribute('data-mode',subscription?'subscription':'one-time');
      publish('mood_purchase_mode_selected',{mode:subscription?'subscription':'one_time',selling_plan_id:subscription&&select?select.value:null});
    }
    modes.forEach(function(input){input.addEventListener('change',sync);});
    if(select)select.addEventListener('change',function(){publish('mood_subscription_plan_selected',{selling_plan_id:select.value});});
    sync();
  });

  window.MOOD_SUBSCRIPTIONS={
    selectedPlanId:function(){
      var root=document.querySelector('[data-mood-subscription-options]');
      if(!root||root.getAttribute('data-mode')!=='subscription') return null;
      var select=root.querySelector('[data-selling-plan-select]');
      return select&&!select.disabled&&select.value?Number(select.value):null;
    }
  };
})();;
(function(){
  'use strict';
  function publish(name,data){if(window.MOOD_EVENTS&&typeof window.MOOD_EVENTS.publish==='function')window.MOOD_EVENTS.publish(name,data||{});}
  function money(cents){return '₪ '+new Intl.NumberFormat('he-IL',{minimumFractionDigits:0,maximumFractionDigits:2}).format((Number(cents)||0)/100);}
  function packPrice(cents,count){return '<span class="mood-ps-pack-price" dir="rtl"><bdi dir="ltr">'+money((Number(cents)||0)/Math.max(1,count))+'</bdi>&nbsp;למארז</span>';}

  var consult=document.querySelector('[data-mood-consult]');
  if(consult)consult.addEventListener('click',function(){publish('mood_consult_clicked',{source:'product'});});

  var subscription=document.querySelector('[data-mood-subscription-options]');
  var product=window.MOOD_SHOPIFY_PRODUCT;
  var selector=document.getElementById('mood-purchase-selector');
  if(subscription&&product&&selector){
    var select=subscription.querySelector('[data-selling-plan-select]');
    var cards=Array.from(selector.querySelectorAll('.mood-ps-card'));
    cards.forEach(function(card){var stack=card.querySelector('.mood-ps-price-stack');if(stack&&!stack.dataset.oneTimeMarkup)stack.dataset.oneTimeMarkup=stack.innerHTML;});
    function unitCount(card){return Number(card.dataset.days||((card.textContent||'').match(/\d+/)||[1])[0])||1;}
    function refreshSubscriptionPrices(){
      var mode=subscription.getAttribute('data-mode');
      var planId=select&&select.value?Number(select.value):null;
      function variantForCard(card){var id=Number(card.dataset.variantId||0);return product.variants.find(function(variant){return Number(variant.id)===id;});}
      cards.forEach(function(card){
        var stack=card.querySelector('.mood-ps-price-stack'),variant=variantForCard(card);if(!stack||!variant)return;
        if(mode!=='subscription'||!planId){if(stack.dataset.oneTimeMarkup)stack.innerHTML=stack.dataset.oneTimeMarkup;return;}
        var allocation=(variant.sellingPlans||[]).find(function(plan){return Number(plan.id)===planId;});if(!allocation)return;
        var count=unitCount(card),pouchCount=Math.max(1,Math.round(count/30));
        stack.innerHTML='<strong class="mood-ps-price">'+money(allocation.price,product.currency)+'</strong><small class="mood-unit-price">'+money(allocation.price/count,product.currency)+' ליחידה / יום</small>'+packPrice(allocation.price,pouchCount);
      });
      var selected=selector.querySelector('.mood-ps-card input:checked'),variant=selected?variantForCard(selected.closest('.mood-ps-card')):variantForCard(selector.querySelector('.mood-ps-card.selected'));
      if(variant){var allocation=mode==='subscription'?(variant.sellingPlans||[]).find(function(plan){return Number(plan.id)===planId;}):null,cta=selector.querySelector('.mood-ps-cta-price');if(cta)cta.textContent=money(allocation?allocation.price:variant.price,product.currency);}
    }
    subscription.addEventListener('change',function(){setTimeout(refreshSubscriptionPrices,0);});
    new MutationObserver(function(mutations){if(mutations.some(function(entry){return entry.attributeName==='data-mode';}))setTimeout(refreshSubscriptionPrices,0);}).observe(subscription,{attributes:true,attributeFilter:['data-mode']});
    cards.forEach(function(card){card.addEventListener('click',function(){setTimeout(refreshSubscriptionPrices,0);});});
    setTimeout(refreshSubscriptionPrices,0);
  }

  var cartRoot=document.querySelector('[data-mood-cart]');
  if(cartRoot){
    var currency=cartRoot.dataset.currency||'ILS',target=Number(cartRoot.dataset.shippingTarget)||30000,status=cartRoot.querySelector('[data-cart-status]');
    function setStatus(message,error){if(!status)return;status.textContent=message||'';status.style.borderColor=error?'#b85d47':'';}
    function updateCount(count){document.querySelectorAll('.bag b,.mood-shell-cart b,[data-cart-count]').forEach(function(node){node.textContent=count;});}
    function renderTotals(cart){
      var total=cartRoot.querySelector('[data-cart-total]');if(total)total.textContent=money(cart.total_price,currency);cartRoot.dataset.cartTotalCents=String(cart.total_price);
      var savings=cartRoot.querySelector('[data-cart-savings]');if(savings){savings.hidden=!cart.total_discount;var strong=savings.querySelector('strong');if(strong)strong.textContent=money(cart.total_discount,currency);}
      var remaining=Math.max(0,target-cart.total_price),progress=Math.min(100,Math.round(cart.total_price*100/target)),copy=cartRoot.querySelector('[data-shipping-copy]'),track=cartRoot.querySelector('[data-shipping-track]');
      if(copy)copy.innerHTML=remaining?'<span>נותרו '+money(remaining,currency)+' למשלוח חינם</span><b>'+progress+'%</b>':'<strong>המשלוח עלינו.</strong><span>✓</span>';
      if(track)track.style.setProperty('--progress',progress+'%');updateCount(cart.item_count);
    }
    var rowUpdates=new WeakMap();
    function setRowBusy(row,busy){row.classList.toggle('is-updating',busy);row.setAttribute('aria-busy',busy?'true':'false');row.querySelectorAll('.mood-cart-qty button,.mood-cart-qty input,[data-cart-remove]').forEach(function(control){control.disabled=busy;});}
    async function performItemChange(row,state){
      var quantity=state.desired;state.running=true;setRowBusy(row,true);setStatus('מעדכן את הסל…');
      try{
        var response=await fetch((window.MOOD_ROUTES&&window.MOOD_ROUTES.cartChange)||'/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:row.dataset.cartKey,quantity:Math.max(0,quantity)})});
        if(!response.ok)throw new Error('cart');var cart=await response.json();if(!cart.item_count){location.reload();return;}
        var item=cart.items.find(function(entry){return entry.key===row.dataset.cartKey;});
        if(!item){row.remove();rowUpdates.delete(row);}
        else{state.confirmed=item.quantity;var input=row.querySelector('input[type="number"]'),price=row.querySelector('[data-line-price]');if(input)input.value=item.quantity;if(price)price.textContent=money(item.final_line_price,currency);}
        renderTotals(cart);publish('mood_cart_quantity_changed',{quantity:item?item.quantity:0});
        if(item&&state.desired!==quantity){state.running=false;return performItemChange(row,state);}
        state.running=false;if(item)setRowBusy(row,false);setStatus('הסל עודכן.');setTimeout(function(){setStatus('');},1800);
      }catch(error){state.running=false;setRowBusy(row,false);var input=row.querySelector('input[type="number"]');if(input)input.value=state.confirmed;state.desired=state.confirmed;setStatus('לא הצלחנו לעדכן. הכמות הקודמת נשמרה.',true);}
    }
    function changeItem(row,quantity){
      if(!row)return;var input=row.querySelector('input[type="number"]'),state=rowUpdates.get(row);
      if(!state){state={running:false,desired:Number(input&&input.value)||0,confirmed:Number(input&&input.value)||0};rowUpdates.set(row,state);}
      state.desired=Math.max(0,quantity);if(input)input.value=state.desired;
      if(!state.running)performItemChange(row,state);
    }
    cartRoot.addEventListener('click',function(event){
      var step=event.target.closest('[data-cart-step]'),remove=event.target.closest('[data-cart-remove]'),upsell=event.target.closest('[data-upsell-variant]');
      if(step){var row=step.closest('[data-cart-key]'),input=row.querySelector('input[type="number"]');changeItem(row,Number(input.value||0)+Number(step.dataset.cartStep));}
      if(remove){changeItem(remove.closest('[data-cart-key]'),0);}
      if(upsell){upsell.disabled=true;setStatus('מוסיף את הרגע לסל…');fetch((window.MOOD_ROUTES&&window.MOOD_ROUTES.cartAdd)||'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(upsell.dataset.upsellVariant),quantity:1}]})}).then(function(response){if(!response.ok)throw new Error('add');publish('mood_cart_upsell_added',{variant_id:Number(upsell.dataset.upsellVariant)});location.reload();}).catch(function(){upsell.disabled=false;setStatus('לא הצלחנו להוסיף. נסו שוב.',true);});}
      var apply=event.target.closest('[data-apply-discount]');if(apply){var code=(cartRoot.querySelector('[data-discount-code]')||{}).value||'';code=code.trim();if(!code){setStatus('הזינו קוד הטבה.',true);return;}publish('mood_discount_entered',{source:'cart'});location.href='/discount/'+encodeURIComponent(code)+'?redirect=/checkout';}
    });
    cartRoot.addEventListener('change',function(event){if(event.target.matches('.mood-cart-qty input'))changeItem(event.target.closest('[data-cart-key]'),Number(event.target.value||0));});
    var form=document.getElementById('MoodCartForm');if(form)form.addEventListener('submit',function(){publish('begin_checkout',{ecommerce:{currency:currency,value:(Number(cartRoot.dataset.cartTotalCents)||0)/100}});});
  }
})();;
(function(){
  'use strict';
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  ready(function(){
    document.documentElement.classList.add('mood-v63','mood-v64','mood-v65','mood-v66','mood-v67');

    /* A full-day offer belongs after proof, not inside the primary decision. */
    var bundle=document.querySelector('.mood-original-page .buy .bundle');
    var reviews=document.querySelector('.mood-original-page #reviews');
    if(bundle&&reviews){bundle.classList.add('mood-bundle-late');reviews.insertAdjacentElement('afterend',bundle);}

    /* Give formula rows a concise, product-safe role without adding claims. */
    var roles={
      energy:{'רודיולה':'הרכיב המרכזי בתערובת','תה ירוק':'מקור טבעי לקפאין','קינמון':'שכבת טעם ארומטית','ליקוריץ':'חלק מפרופיל הטעם','גוארנה':'מקור טבעי לקפאין'},
      relax:{'מליסה':'רכיב בוטני מסורתי','כשות':'רכיב בוטני מסורתי','רודיולה':'חלק מתערובת BALANCE','ולריאן':'רכיב בוטני מסורתי','לבנדר':'שכבה ארומטית','קמומיל':'רכיב בוטני מסורתי','ליקוריץ':'חלק מפרופיל הטעם'},
      sleep:{'פסיפלורה':'רכיב בוטני מסורתי','ולריאן':'רכיב בוטני מסורתי','כשות':'רכיב בוטני מסורתי','מליסה':'רכיב בוטני מסורתי'}
    };
    var page=document.body.getAttribute('data-page')||((document.body.className.match(/mood-page-(energy|relax|sleep)/)||[])[1]);
    document.querySelectorAll('.mood-original-page #formula .ing-list>div').forEach(function(row){
      var name=row.querySelector('strong');if(!name)return;
      var latin=row.querySelector('span');
      if(latin&&roles[page]&&roles[page][name.textContent.trim()])latin.textContent=roles[page][name.textContent.trim()];
      var hint=row.querySelector('.mood-ingredient-hint');if(hint)hint.setAttribute('title','פתיחת מידע ומקור');
    });

    /* The purchase action names the exact pack and communicates state. */
    var selector=document.getElementById('mood-purchase-selector');
    if(selector){
      var purchaseButton=selector.querySelector('.mood-ps-cta');
      var purchaseLive=selector.querySelector('.mood-purchase-live');
      function selectedCard(){return selector.querySelector('.mood-ps-card input:checked')?.closest('.mood-ps-card')||selector.querySelector('.mood-ps-card.selected,.mood-ps-card[aria-checked="true"]');}
      function syncPurchaseLabel(){var card=selectedCard(),label=purchaseButton&&purchaseButton.querySelector('.mood-ps-cta-label');if(card&&label&&!purchaseButton.disabled)label.textContent='הוספת '+(card.dataset.days||'המארז')+' יום לסל';}
      selector.querySelectorAll('.mood-ps-card').forEach(function(card){card.addEventListener('click',function(){setTimeout(syncPurchaseLabel,0);});});
      if(purchaseButton){
        new MutationObserver(function(){var busy=purchaseButton.disabled||/מוסיף/.test(purchaseButton.textContent);purchaseButton.setAttribute('aria-busy',busy?'true':'false');if(purchaseLive&&busy)purchaseLive.textContent='מוסיפים את הרגע שבחרתם…';}).observe(purchaseButton,{attributes:true,childList:true,subtree:true,attributeFilter:['disabled']});
        syncPurchaseLabel();
      }
    }

    /* One cart drawer everywhere: real cart contents, shipping progress and focus recovery. */
    var drawer=document.querySelector('[data-mood-cart-drawer]');
    var drawerBackdrop=document.querySelector('[data-mood-cart-backdrop]');
    if(drawer&&drawerBackdrop&&!drawer.dataset.v64Ready){
      drawer.dataset.v64Ready='true';
      var drawerLastFocus=null;
      var drawerItems=drawer.querySelector('[data-drawer-items]');
      var drawerAdded=drawer.querySelector('[data-drawer-added]');
      var drawerEmpty=drawer.querySelector('[data-drawer-empty]');
      var drawerSummary=drawer.querySelector('.mood-drawer-summary');
      var drawerStatus=drawer.querySelector('[data-drawer-status]');
      var drawerCrossSell=drawer.querySelector('[data-drawer-cross-sell]');
      var drawerRequest=null;
      var drawerRecommendationRequest=null;
      var recommendationMap={'mood-energy':'mood-relax','mood-relax':'mood-sleep','mood-sleep':'mood-energy'};
      var recommendationLabels={'mood-energy':'MORE · להיכנס לקצב','mood-relax':'BALANCE · להוריד הילוך','mood-sleep':'DREAM · לסגור את היום'};
      function drawerPublish(name,data){if(window.MOOD_EVENTS&&typeof window.MOOD_EVENTS.publish==='function')window.MOOD_EVENTS.publish(name,data||{});}
      function drawerMoney(cents,currency){try{return new Intl.NumberFormat('he-IL',{style:'currency',currency:currency||'ILS',maximumFractionDigits:0}).format((Number(cents)||0)/100);}catch(error){return '₪ '+Math.round((Number(cents)||0)/100);}}
      function drawerPackLabel(item){var text=item.variant_title||'';if(/30/.test(text))return 'חבילת 30 יום';if(/60/.test(text))return 'חבילת 60 יום';if(/90/.test(text))return 'חבילת 90 יום';return text&&text!=='Default Title'?text:'';}
      function makeItem(item,currency){
        var row=document.createElement('article');row.className='mood-drawer-item';row.dataset.drawerKey=item.key;row.setAttribute('aria-busy','false');
        var imageLink=document.createElement('a');imageLink.className='mood-drawer-item-image';imageLink.href=item.url||'#';imageLink.setAttribute('aria-label',item.product_title||item.title||'מוצר');
        var image=document.createElement('img');image.width=64;image.height=64;image.loading='lazy';image.alt='';if(item.image)image.src=item.image;imageLink.appendChild(image);
        var copy=document.createElement('div');copy.className='mood-drawer-item-copy';
        var title=document.createElement('a');title.className='mood-drawer-item-title';title.href=item.url||'#';title.textContent=item.product_title||item.title||'';
        var meta=document.createElement('span');meta.className='mood-drawer-item-meta';meta.textContent=drawerPackLabel(item);
        copy.append(title);if(meta.textContent)copy.append(meta);
        if(item.selling_plan_allocation){var plan=document.createElement('span');plan.className='mood-drawer-plan';var planName=item.selling_plan_allocation.selling_plan&&item.selling_plan_allocation.selling_plan.name;plan.textContent='מנוי מתחדש'+(planName?' · '+planName:'')+' · ניתן לדלג או לבטל';copy.append(plan);}
        var controls=document.createElement('div');controls.className='mood-drawer-item-controls';controls.setAttribute('aria-label','בחירת כמות');
        var minus=document.createElement('button');minus.type='button';minus.dataset.drawerStep='-1';minus.setAttribute('aria-label','הפחתת כמות');minus.textContent='−';
        var quantity=document.createElement('input');quantity.type='number';quantity.min='0';quantity.inputMode='numeric';quantity.value=String(item.quantity);quantity.dataset.drawerQuantity='';quantity.setAttribute('aria-label','כמות עבור '+(item.product_title||item.title||'המוצר'));
        var plus=document.createElement('button');plus.type='button';plus.dataset.drawerStep='1';plus.setAttribute('aria-label','הגדלת כמות');plus.textContent='+';
        var remove=document.createElement('button');remove.type='button';remove.className='mood-drawer-remove';remove.dataset.drawerRemove='';remove.textContent='הסרה';remove.setAttribute('aria-label','הסרת '+(item.product_title||item.title||'המוצר')+' מהסל');controls.append(minus,quantity,plus,remove);copy.append(controls);
        var price=document.createElement('div');price.className='mood-drawer-item-price';var finalPrice=document.createElement('strong');finalPrice.textContent=drawerMoney(item.final_line_price,currency);price.append(finalPrice);
        if(Number(item.original_line_price)>Number(item.final_line_price)){var original=document.createElement('del');original.textContent=drawerMoney(item.original_line_price,currency);price.prepend(original);}
        row.append(imageLink,copy,price);return row;
      }
      function clearRecommendation(){if(!drawerCrossSell)return;drawerCrossSell.hidden=true;drawerCrossSell.removeAttribute('data-variant-id');}
      function renderRecommendation(product,currency){
        if(!drawerCrossSell||!product)return clearRecommendation();var variant=(product.variants||[]).find(function(entry){return entry.available;});if(!variant)return clearRecommendation();
        var title=drawerCrossSell.querySelector('[data-cross-sell-title]'),price=drawerCrossSell.querySelector('[data-cross-sell-price]'),image=drawerCrossSell.querySelector('[data-cross-sell-image]'),links=drawerCrossSell.querySelectorAll('[data-cross-sell-link],[data-cross-sell-title]');var url='/products/'+product.handle;
        links.forEach(function(link){link.href=url;});if(title)title.textContent=recommendationLabels[product.handle]||product.title;if(price)price.textContent=drawerMoney(variant.price,currency);if(image){image.src=(product.featured_image||'').replace(/^\/\//,'https://');image.alt=product.title;}
        drawerCrossSell.dataset.variantId=variant.id;drawerCrossSell.hidden=false;
      }
      function syncRecommendation(cart){
        clearRecommendation();if(!drawerCrossSell||!cart.items||!cart.items.length)return;var handles=cart.items.map(function(item){return item.handle;});var target='';handles.some(function(handle){var candidate=recommendationMap[handle];if(candidate&&handles.indexOf(candidate)===-1){target=candidate;return true;}return false;});if(!target)return;
        var requestToken=target;drawerRecommendationRequest=requestToken;fetch('/products/'+target+'.js',{headers:{Accept:'application/json'}}).then(function(response){if(!response.ok)throw new Error('product');return response.json();}).then(function(product){if(drawerRecommendationRequest===requestToken)renderRecommendation(product,cart.currency);}).catch(clearRecommendation);
      }
      function renderDrawer(cart){
        var total=drawer.querySelector('[data-drawer-total]');if(total)total.textContent=drawerMoney(cart.total_price,cart.currency);
        var savings=drawer.querySelector('[data-drawer-savings]'),savingsValue=drawer.querySelector('[data-drawer-savings-value]');if(savings){savings.hidden=!cart.total_discount;if(savingsValue)savingsValue.textContent=drawerMoney(cart.total_discount,cart.currency);}
        var target=Number(drawer.dataset.shippingTarget)||30000,remaining=Math.max(0,target-cart.total_price),progress=Math.min(100,Math.round(cart.total_price*100/target));
        var shippingCopy=drawer.querySelector('[data-drawer-shipping-copy]'),shippingBar=drawer.querySelector('[data-drawer-shipping-bar]');if(shippingCopy)shippingCopy.textContent=remaining?'נותרו '+drawerMoney(remaining,cart.currency)+' למשלוח חינם':'המשלוח עלינו ✓';if(shippingBar)shippingBar.style.width=progress+'%';
        drawerItems.replaceChildren();(cart.items||[]).forEach(function(item){drawerItems.appendChild(makeItem(item,cart.currency));});
        var empty=!cart.item_count;drawerItems.hidden=empty;drawerEmpty.hidden=!empty;drawerSummary.hidden=empty;
        var points=drawer.querySelector('[data-drawer-points]');if(points)points.textContent='צוברים '+Math.floor((Number(cart.total_price)||0)/100)+' נק׳';
        syncRecommendation(cart);
        if(drawerAdded)drawerAdded.hidden=empty||drawer.dataset.openMode!=='added'||!drawerAdded.querySelector('.mood-cart-product')?.textContent.trim();
        document.querySelectorAll('.bag b,.mood-shell-cart b,[data-cart-count]').forEach(function(node){node.textContent=cart.item_count;});
      }
      function setDrawerBusy(row,busy){row?.setAttribute('aria-busy',busy?'true':'false');row?.querySelectorAll('button,input').forEach(function(control){control.disabled=busy;});drawer.classList.toggle('is-updating',busy);}
      function changeDrawerItem(row,quantity){
        if(!row||drawerRequest)return;var input=row.querySelector('[data-drawer-quantity]'),previous=Number(input&&input.value)||0,next=Math.max(0,Number(quantity)||0);if(input)input.value=String(next);setDrawerBusy(row,true);if(drawerStatus)drawerStatus.textContent='מעדכנים את הסל…';
        drawerRequest=fetch((window.MOOD_ROUTES&&window.MOOD_ROUTES.cartChange)||'/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:row.dataset.drawerKey,quantity:next})}).then(function(response){if(!response.ok)throw new Error('cart');return response.json();}).then(function(cart){drawer.dataset.openMode='browse';renderDrawer(cart);drawerPublish(next?'mood_cart_quantity_changed':'mood_cart_item_removed',{quantity:next,source:'drawer'});if(drawerStatus)drawerStatus.textContent=next?'הסל עודכן.':'המוצר הוסר מהסל.';setTimeout(function(){if(drawerStatus)drawerStatus.textContent='';},1600);}).catch(function(){if(input)input.value=String(previous);if(drawerStatus)drawerStatus.textContent='לא הצלחנו לעדכן. נסו שוב.';}).finally(function(){drawerRequest=null;setDrawerBusy(row,false);});
      }
      function addRecommendation(){
        if(!drawerCrossSell||drawerRequest)return;var variantId=Number(drawerCrossSell.dataset.variantId),button=drawerCrossSell.querySelector('[data-cross-sell-add]');if(!variantId)return;drawerRequest=true;if(button){button.disabled=true;button.textContent='מוסיפים…';}if(drawerStatus)drawerStatus.textContent='מוסיפים את ההמלצה לסל…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})}).then(function(response){if(!response.ok)throw new Error('add');return response.json();}).then(function(){return hydrateDrawer();}).then(function(){drawerPublish('mood_cart_cross_sell_added',{variant_id:variantId,source:'drawer'});if(drawerStatus)drawerStatus.textContent='נוסף לסל.';}).catch(function(){if(drawerStatus)drawerStatus.textContent='לא הצלחנו להוסיף. אפשר לפתוח את עמוד המוצר.';}).finally(function(){drawerRequest=null;if(button){button.disabled=false;button.textContent='הוספה';}});
      }
      function hydrateDrawer(){drawer.setAttribute('aria-busy','true');if(drawerStatus)drawerStatus.textContent='מעדכנים את הסל…';return fetch(((window.MOOD_ROUTES&&window.MOOD_ROUTES.cart)||'/cart')+'.js',{headers:{Accept:'application/json'}}).then(function(response){if(!response.ok)throw new Error('cart');return response.json();}).then(function(cart){renderDrawer(cart);if(drawerStatus)drawerStatus.textContent='';}).catch(function(){if(drawerStatus)drawerStatus.textContent='לא הצלחנו לעדכן את הסל. ניתן לעבור לעמוד הסל.';}).finally(function(){drawer.removeAttribute('aria-busy');});}
      function setAdded(detail){var variant=detail&&detail.variant,product=detail&&detail.product;if(!variant||!product)return;var name=drawer.querySelector('.mood-cart-product'),variantName=drawer.querySelector('.mood-cart-variant'),price=drawer.querySelector('.mood-cart-price');if(name)name.textContent=product.title||'';if(variantName)variantName.textContent=variant.title||'';if(price)price.textContent=drawerMoney(variant.price,product.currency);}
      function revealDrawer(trigger,mode){drawer.dataset.openMode=mode||'browse';drawerLastFocus=trigger||document.activeElement;drawer.hidden=false;drawerBackdrop.hidden=false;document.body.classList.add('mood-cart-open');setTimeout(function(){drawer.querySelector('.mood-cart-close')?.focus();},0);}
      function openGlobalDrawer(trigger){revealDrawer(trigger,'browse');hydrateDrawer();}
      function openAdded(detail){setAdded(detail);revealDrawer(detail&&detail.trigger,'added');if(detail&&detail.cart){renderDrawer(detail.cart);if(drawerStatus)drawerStatus.textContent='נוסף לסל.';}else hydrateDrawer();if(purchaseLive)purchaseLive.textContent='נוסף לסל. אפשר להמשיך לקופה או להמשיך לגלוש.';}
      function closeGlobalDrawer(){drawer.hidden=true;drawerBackdrop.hidden=true;document.body.classList.remove('mood-cart-open');if(drawerLastFocus&&drawerLastFocus.focus)drawerLastFocus.focus();}
      drawer.querySelector('.mood-cart-close')?.addEventListener('click',closeGlobalDrawer);drawer.querySelector('.mood-cart-continue')?.addEventListener('click',closeGlobalDrawer);drawerBackdrop.addEventListener('click',closeGlobalDrawer);
      drawerItems.addEventListener('click',function(event){var row=event.target.closest('[data-drawer-key]'),step=event.target.closest('[data-drawer-step]'),remove=event.target.closest('[data-drawer-remove]');if(step){var input=row.querySelector('[data-drawer-quantity]');changeDrawerItem(row,(Number(input.value)||0)+Number(step.dataset.drawerStep));}if(remove)changeDrawerItem(row,0);});
      drawerItems.addEventListener('change',function(event){if(event.target.matches('[data-drawer-quantity]'))changeDrawerItem(event.target.closest('[data-drawer-key]'),event.target.value);});
      drawerCrossSell?.querySelector('[data-cross-sell-add]')?.addEventListener('click',addRecommendation);
      drawer.querySelector('.mood-cart-checkout')?.addEventListener('click',function(){drawerPublish('begin_checkout',{source:'drawer'});});
      document.addEventListener('click',function(event){var link=event.target.closest('a[href$="/cart"],.bag,.mood-shell-cart');if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||document.body.classList.contains('mood-page-cart'))return;event.preventDefault();openGlobalDrawer(link);});
      document.addEventListener('mood:cart:added',function(event){openAdded(event.detail||{});});
      document.addEventListener('keydown',function(event){if(drawer.hidden)return;if(event.key==='Escape'){event.preventDefault();closeGlobalDrawer();return;}if(event.key==='Tab'){var nodes=Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')).filter(function(node){return !node.hidden&&node.offsetParent!==null;});if(!nodes.length)return;var first=nodes[0],last=nodes[nodes.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}}});
      window.MOOD_CART_DRAWER={open:openGlobalDrawer,openAdded:openAdded,close:closeGlobalDrawer,refresh:hydrateDrawer};
      if(window.MOOD_PENDING_CART_ADDED){openAdded(window.MOOD_PENDING_CART_ADDED);window.MOOD_PENDING_CART_ADDED=null;}
    }

    /* On small screens the footer starts collapsed, reducing the final scroll. */
    var footerGroups=Array.from(document.querySelectorAll('.mfoot-col'));
    function syncFooterGroups(){footerGroups.forEach(function(group){if(window.matchMedia('(max-width:900px)').matches)group.removeAttribute('open');else group.setAttribute('open','');});}
    if(footerGroups.length){syncFooterGroups();window.matchMedia('(max-width:900px)').addEventListener?.('change',syncFooterGroups);}
  });
})();;
(function () {
  var rotator = document.querySelector('.mood-product-ann__rotator');
  if (rotator && rotator.dataset.moodAnnInitialized !== 'true') {
    rotator.dataset.moodAnnInitialized = 'true';
    rotator.setAttribute('aria-hidden', 'false');
    var slides = Array.prototype.slice.call(rotator.querySelectorAll('.mood-product-ann__slide'));
    if (slides.length) {
      var activeIndex = 0;
      var live = document.createElement('div');
      live.className = 'mood-product-ann__live';
      live.setAttribute('aria-live', 'polite');
      slides.forEach(function (slide) {
        slide.dataset.moodAnnSource = 'true';
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('inert', '');
      });
      rotator.appendChild(live);

      function showSlide(index) {
        rotator.dataset.moodAnnIndex = String(index);
        var source = slides[index].cloneNode(true);
        source.classList.remove('mood-product-ann__slide', 'is-active');
        source.removeAttribute('style');
        source.removeAttribute('aria-hidden');
        source.removeAttribute('inert');
        source.removeAttribute('tabindex');
        source.removeAttribute('data-mood-ann-source');
        live.replaceChildren(source);
      }

      showSlide(activeIndex);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && slides.length > 1) {
        rotator.dataset.moodAnnRunning = 'true';
        var scheduleNext = function () {
          window.setTimeout(function () {
            if (!document.hidden) {
              activeIndex = (activeIndex + 1) % slides.length;
              live.style.opacity = '0';
              window.setTimeout(function () {
                showSlide(activeIndex);
                live.style.opacity = '1';
              }, 200);
            }
            scheduleNext();
          }, 4500);
        };
        scheduleNext();
      }
    }
  }

  var root = document.getElementById('mood-purchase-selector');
  if (!root) return;

  var primary = root.querySelector('.mood-ps-primary-cta');
  var floating = root.querySelector('.mood-ps-floating-cta');
  var sticky = root.querySelector('.mood-ps-sticky');
  if (!primary || !floating || !sticky) return;

  var cardGroup = root.querySelector('.mood-ps-cards');
  var footer = document.querySelector('footer.mfoot, .mfoot');
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var passedChoices = false;
  var footerVisible = false;
  var syncStickyPosition = function () {
    var mobile = mobileQuery.matches;
    sticky.setAttribute('data-armed', mobile && passedChoices ? 'true' : 'false');
    sticky.classList.toggle('is-footer-hidden', Boolean(mobile && footerVisible));
  };

  if ('IntersectionObserver' in window) {
    if (cardGroup) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        passedChoices = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        syncStickyPosition();
      }, { threshold: 0 }).observe(cardGroup);
    }
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        syncStickyPosition();
      }, { rootMargin: '0px 0px -12px 0px', threshold: 0 }).observe(footer);
    }
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncStickyPosition);
    else if (mobileQuery.addListener) mobileQuery.addListener(syncStickyPosition);
    syncStickyPosition();
  } else {
    var scrollTicking = false;
    var updateStickyPosition = function () {
      scrollTicking = false;
      if (!mobileQuery.matches) {
        passedChoices = false;
        footerVisible = false;
      } else {
        passedChoices = Boolean(cardGroup && cardGroup.getBoundingClientRect().bottom < 0);
        footerVisible = Boolean(footer && footer.getBoundingClientRect().top < window.innerHeight - 12);
      }
      syncStickyPosition();
    };
    var requestStickyUpdate = function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(updateStickyPosition);
    };
    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate, { passive: true });
    updateStickyPosition();
  }

  function mirrorPrimary() {
    floating.innerHTML = primary.innerHTML;
    floating.disabled = primary.disabled;
    floating.setAttribute('aria-disabled', primary.disabled ? 'true' : 'false');
  }

  mirrorPrimary();
  new MutationObserver(mirrorPrimary).observe(primary, {
    attributes: true,
    attributeFilter: ['disabled'],
    childList: true,
    characterData: true,
    subtree: true
  });

  floating.addEventListener('click', function () { primary.click(); });

  var updateAccessibility = function () {
    var armed = sticky.getAttribute('data-armed') === 'true' && !sticky.classList.contains('is-footer-hidden');
    sticky.setAttribute('aria-hidden', armed ? 'false' : 'true');
    floating.tabIndex = armed ? 0 : -1;
  };
  new MutationObserver(updateAccessibility).observe(sticky, {
    attributes: true,
    attributeFilter: ['data-armed', 'class']
  });
  updateAccessibility();
})();;
(function () {
  'use strict';

  var root = document.documentElement;
  var viewport = window.visualViewport;
  var frame = 0;

  function updateInset() {
    frame = 0;
    if (!window.matchMedia('(max-width: 767px)').matches || !viewport) {
      root.style.removeProperty('--mood-v99-browser-inset');
      return;
    }

    var layoutHeight = Math.max(window.innerHeight, document.documentElement.clientHeight);
    var covered = Math.max(0, layoutHeight - viewport.height - viewport.offsetTop);
    root.style.setProperty('--mood-v99-browser-inset', Math.min(Math.round(covered), 124) + 'px');
  }

  function requestUpdate() {
    if (frame) return;
    frame = window.requestAnimationFrame(updateInset);
  }

  function normalizePurchaseCopy() {
    document.querySelectorAll('.mood-ps-cta-label').forEach(function (label) {
      var match = label.textContent.match(/(30|60|90)/);
      var next = match ? 'הוספה לסל · ' + match[1] + ' יום' : '';
      if (next && label.textContent !== next) label.textContent = next;
    });
  }

  updateInset();
  normalizePurchaseCopy();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('orientationchange', requestUpdate, { passive: true });
  if (viewport) {
    viewport.addEventListener('resize', requestUpdate, { passive: true });
    viewport.addEventListener('scroll', requestUpdate, { passive: true });
  }

  var purchase = document.getElementById('mood-purchase-selector');
  if (purchase) {
    new MutationObserver(normalizePurchaseCopy).observe(purchase, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
})();;
/* MOOD V100 — accessible review carousel state on mobile. */
(function () {
  function init(section) {
    var row = section.querySelector('[data-mood-reviews]');
    var cards = Array.prototype.slice.call(row ? row.querySelectorAll('.rvq') : []);
    var dots = Array.prototype.slice.call(section.querySelectorAll('.mood-review-dots button'));
    if (!row || !cards.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function nearestCard() {
      var rowBox = row.getBoundingClientRect();
      var center = rowBox.left + rowBox.width / 2;
      var bestIndex = 0;
      var bestDistance = Infinity;
      cards.forEach(function (card, index) {
        var box = card.getBoundingClientRect();
        var distance = Math.abs(box.left + box.width / 2 - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });
      setActive(bestIndex);
    }

    var scrollTimer;
    row.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(nearestCard, 70);
    }, { passive: true });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        cards[index].scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
        setActive(index);
      });
    });

    setActive(0);
  }

  function start() {
    document.querySelectorAll('.mood-reviews-v100').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();;

